import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";

const ComingSoon = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="40px auto"
      p="30px"
      maxWidth="800px"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      <Typography variant="h1" color="#5D6D7E" mb={3}>
        Coming Soon ... 
      </Typography>
    </Box>
  );
};

export default ComingSoon;
